import { defaultTableSettings } from "src/components";
import { ITableSettings, useSettings } from "src/hooks";

const useTableSettings = (tableId: string) => {
  const {
    tableSettings: { [tableId]: unsafeSettings },
    updateTableSettings,
  } = useSettings();

  const safeSettings: ITableSettings = {
    ...defaultTableSettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<ITableSettings>) => {
      updateTableSettings(tableId, updatedSettings);
    },
  };
};

export { useTableSettings };
